export default class playVideo {

    static init() {

        var vid = document.getElementById("video-2");

        function playVid() {
            vid.play();
        }

        function pauseVid() {
            vid.pause();
        }


        $("#btn-pause").on("click", function() {
            pauseVid();
            $(this).hide();
            $("#btn-play").show();
        });

        $("#btn-play").on("click", function() {
            playVid();
            $(this).hide();
            $("#btn-pause").show();
        });


    }

}